import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

/**
 * Link para o pedido em relatórios.
 */
export default function ReportSaleLink({ saleId, children, className }) {
    const label = children ?? '-';

    if (saleId == null) {
        return <span className={className}>{label}</span>;
    }

    return (
        <Link
            to={`/sales/${saleId}`}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
                'text-primary-600 hover:text-primary-800 hover:underline font-medium',
                className,
            )}
        >
            {label}
        </Link>
    );
}
